import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { ShieldCheck } from 'lucide-react';

const insurancePartners = [
  { name: 'Star Health', color: '#e31837' },
  { name: 'New India', color: '#003d7c' },
  { name: 'United India', color: '#1a5276' },
  { name: 'ICICI Lombard', color: '#f58220' },
  { name: 'HDFC Ergo', color: '#004c8f' },
  { name: 'Bajaj Allianz', color: '#0066b2' },
  { name: 'Medi Assist', color: '#00a3e0' },
  { name: 'Vidal Health', color: '#6b2d7b' },
  { name: 'FHPL', color: '#e63946' },
  { name: 'Paramount', color: '#2e7d32' },
];

const InsuranceSection = () => {
  const { language } = useLanguage();

  return (
    <section className="py-10 bg-white border-t border-gray-100" data-testid="insurance-section">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-6">
          <div className="inline-flex items-center gap-2 mb-2">
            <ShieldCheck size={18} className="text-[#0066b3]" />
            <span className="text-sm font-semibold text-[#0f172a]">
              {language === 'ta' ? 'காப்பீடு & TPA இணைப்புகள்' : 'Cashless Insurance & TPA Partners'}
            </span>
          </div>
          <p className="text-xs text-[#64748b]">
            {language === 'ta' ? 'அனைத்து முக்கிய காப்பீட்டு நிறுவனங்களும் ஏற்றுக்கொள்ளப்படுகின்றன' : 'All major insurance companies accepted. Hassle-free cashless treatment.'}
          </p>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4">
          {insurancePartners.map((partner) => (
            <div
              key={partner.name}
              className="px-4 py-2 rounded-lg border border-gray-100 bg-[#f8fafc] hover:shadow-sm transition-shadow"
              data-testid={`insurance-${partner.name.toLowerCase().replace(/\s+/g, '-')}`}
            >
              <span className="text-xs font-bold" style={{ color: partner.color }}>{partner.name}</span>
            </div>
          ))}
        </div>

        <p className="text-center mt-4 text-[10px] text-[#94a3b8]">
          {language === 'ta' ? '& மேலும் 50+ TPA/காப்பீட்டு நிறுவனங்கள்' : '& 50+ more TPA/Insurance companies. Contact us for your specific insurer.'}
        </p>
      </div>
    </section>
  );
};

export default InsuranceSection;
